import request from '@/sheep/request';

const SpecialApi = {
    // 获取子分类
    getListByParent: (params) => {
        return request({
            url: '/operation/product/category/list-by-parent',
            method: 'GET',
            params
        });
    },
    // 查询商品
    getProductList: (params) => {
        return request({
            url: '/operation/product/list',
            method: 'GET',
            params,
            custom: {
                showLoading: false,
            },
        });
    }
};

export default SpecialApi;
